import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import platform from "Pub/js/platform";
import { langCheck, } from "Pub/js/utils";
const { pageTo } = platform;
const { NCTooltip } = platform.base;
import { setStore, getStore } from "Pub/js/storageUtils";
import { getCurrentLangText } from "Pub/js/getMulti";

const global_search = "global_search"

class HistoryPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            curFocus: 0,  //视觉焦点 
            tip: "", //提示内容文本
        }
    }

    componentDidMount() {
        //监听箭头事件
        let { refInput } = this.props
        if (refInput) {
            refInput.addEventListener('keydown', this.handleKeyDown)
        }
    }

    componentWillReceiveProps(nextProps) {

        if (!nextProps.focus) {
            setTimeout(() => {
                this.setState({
                    curFocus: 0
                })
            }, 500)
        }
    }
    componentWillUnmount() {
        let { refInput } = this.props
        if (refInput) {
            refInput.removeEventListener('keydown', this.handleKeyDown)
        }
    }

    handleKeyDown = (e) => {
        let { curFocus } = this.state
        let panelData = this.getPanelData() || {}
        let history = panelData.history || []
        let viewed = panelData.viewed || []
        let length = history.length + viewed.length

        //Enter 键
        if (e.keyCode === 13) {
            if (curFocus === 0) {
                this.handleMoreClick()
            } else if (0 < curFocus && curFocus < history.length + 1) {
                this.handleHistoryClick(history[curFocus - 1])
            } else {
                this.handleViewedClick(viewed[curFocus - history.length - 1], curFocus - history.length - 1)
            }
        }
        // 上箭头
        if (e.keyCode === 38 && curFocus !== 0) {
            this.setState({
                curFocus: curFocus - 1
            })
        }
        //下箭头
        if (e.keyCode === 40 && curFocus < length) {
            this.setState({
                curFocus: curFocus + 1
            })
        }
    }


    render() {
        let { curFocus, tip } = this.state
        // 判空处理
        let panelData = this.getPanelData() || {},
            history = panelData.history || [],
            viewed = panelData.viewed || [],
            hasHistory = !!history.length,
            hasViewed = !!viewed.length
        return <div
            className="search-history"
            onMouseDown={(e) => e.preventDefault()}
        >
            <a
                className={` search-more ${curFocus === 0 ? "active-background" : ""}`}
                onClick={() => this.handleMoreClick()}
                onMouseEnter={() => this.setState({ curFocus: 0 })}
            >
                {langCheck("0000PUB-000546")  /* 国际化处理： 搜索更多结果*/}
                <i className='icon iconfont icon-jiantouyou arrow-icon' />
            </a>
            <hr className='hr' />
            {hasHistory || hasViewed
                ?
                <div>
                    {hasHistory
                        &&
                        <div>
                            <div className="title">
                                <p className="title-text">{langCheck("0000PUB-000547")  /* 国际化处理： 搜索历史*/}</p>
                                <i
                                    className="icon iconfont icon-gsbjq-shanchu title-icon  "
                                    onClick={() => this.handleClear('history')}
                                />
                            </div>
                            {history.map((item, i) => {
                                return <NCTooltip
                                    overlay={tip === item ? item : ""}
                                    placement="right"
                                >
                                    <div
                                        className={` item ${curFocus === i + 1 ? "active-background" : ""}`}
                                        onClick={() => this.handleHistoryClick(item, i)}
                                        onMouseEnter={
                                            () => {
                                                this.setState({ curFocus: i + 1 })
                                                if (this.isRenderTip(`.history-text-width${i}`, 185)) {
                                                    this.setState({ tip: item })
                                                }
                                            }
                                        }
                                        onMouseLeave={() => { this.setState({ tip: "" }) }}
                                    >

                                        <span
                                            className="item-text"
                                        >
                                            <i class="icon iconfont icon-icon-zuijfw" style={{ color: '#999999' }} />

                                            <span
                                                className={`history-text-width${i}`}
                                            >
                                                {item}
                                            </span>

                                        </span>
                                        <i
                                            className={`icon iconfont icon-shenpibohui item-icon ${curFocus === i + 1 ? "close-active" : ""}`}
                                            onClick={(e) => this.handleDelete(e, 'history', i)}
                                        />
                                    </div>
                                </NCTooltip>
                            })}
                        </div>
                    }

                    {hasViewed
                        &&
                        <div >
                            <div className="title">
                                <p
                                    className="title-text"
                                >
                                    {langCheck("0000PUB-000548")  /* 国际化处理： 最近浏览*/}
                                </p>
                                <i
                                    className=" icon iconfont icon-gsbjq-shanchu title-icon  "
                                    onClick={() => this.handleClear('viewed')}
                                >
                                </i>
                            </div>
                            {viewed.map((record, i) => {
                                const display = getCurrentLangText('label', record.labelMap) || record.display;
                                return <NCTooltip
                                    overlay={tip === display ? display : ""}
                                    placement="right"
                                >
                                    <div
                                        className={` item ${curFocus === history.length + i + 1 ? "active-background" : ""}`}
                                        onClick={() => this.handleViewedClick(record, i)}
                                        onMouseEnter={
                                            () => {
                                                this.setState({ curFocus: history.length + i + 1 })
                                                if (this.isRenderTip(`.view-text-width${i}`, 185)) {
                                                    this.setState({ tip: display })
                                                }
                                            }
                                        }
                                        onMouseLeave={() => { this.setState({ tip: "" }) }}
                                    >

                                        <div
                                            className="item-text"
                                        >
                                            <i class={`icon iconfont ${viewed[i].icon} `} style={{ color: '#979797' }} />
                                            <span
                                                className={`view-text-width${i}`}
                                            >
                                                {display}
                                            </span>

                                        </div>
                                        <i
                                            className={`icon iconfont icon-shenpibohui item-icon ${curFocus === history.length + i + 1 ? "close-active" : ""}`}
                                            onClick={(e) => this.handleDelete(e, 'viewed', i)}
                                        />
                                    </div>
                                </NCTooltip>
                            })}
                        </div>
                    }
                </div>
                :
                <div className="empty-data">
                    <i className='icon iconfont icon-sousuo1 icon-empty'></i>
                    <span>{langCheck("0000PUB-000549")  /* 国际化处理：暂无搜索历史*/}</span>
                </div>
            }

        </div>
    }

    /**
     * 获取面板数据
     */
    getPanelData = () => {
        const userId = (getStore("STOREFORINFODATA", true) || {}).userId;
        return (getStore(global_search) || {})[userId]
    }

    /**
     * 覆盖原有面板数据
     * @param {string} key  寻找要替换的旧值  
     * @param {string} data 更新旧值为data
     */
    setPanelData = (key, data) => {
        const userId = (getStore("STOREFORINFODATA", true) || {}).userId;
        let panelData = this.getPanelData()
        panelData[key] = data
        setStore(global_search, { [userId]: panelData })
    }

    /**
     * 删除历史/浏览记录
     * @param {string} key  key判断历史数据还是最近浏览数据
     * @param {string} index  删除项标志位  
     */
    handleDelete = (e, key, index) => {
        e.stopPropagation();
        //获取历史纪录或最近浏览
        let panelData = this.getPanelData()
        let data = panelData[key]

        //删除
        data.splice(index, 1)
        //更新本地panelData数据
        this.setPanelData(key, data)
        //更新页面
        this.forceUpdate()
    }

    /**
     * 清空历史/浏览纪录
     * @param {string} key 区分历史数据还是最近浏览数据
     */
    handleClear = (key) => {
        //更新本地panelData数据
        this.setPanelData(key, [])
        //更新页面
        this.forceUpdate()
    }

    // 打开“搜索更多”新页面
    handleMoreClick = () => {
        let { type, onHidden } = this.props
        onHidden()
        // 跳转到全局搜索中心 TOD0：页面跳转时，旧页面会被挂起,因此需要先关闭面板，后跳转
        setTimeout(() => {
            pageTo.openTo("../../../../uapwb/gsc/center/list/index.html", {
                appcode: "00221301",
                pagecode: "00221301GSC_list",
                status: 'browse',
                titleKey: "noTitleKey",
                keyword: "noKeyword",
                selectKey: type.key,
                searchCenterPage: true,
                tabName: langCheck("0000PUB-000545")  /* 国际化处理： 全局搜索中心*/
            });
        }, 150)
        //配合全局搜索中心
        setStore('refresh_page', false)
    }

    /**
     * 点击历史纪录
     * @param {string} index  每条纪录的index
     */
    handleHistoryClick = (item, index) => {
        let panelData = this.getPanelData()
        //将点击值设置到搜索框上
        this.props.onHistoryClick(item);
        //改变记录顺序
        let data = this.setFront(panelData['history'], index)
        //更新本地panelData
        this.setPanelData('history', data)
    }

    /**
      * 点击最近浏览
      * @param {string} item  每条浏览纪录的信息
      * @param {string} index 浏览纪录的index
      */
    handleViewedClick = (item, index) => {
        let { id, appcode, pagecode } = item || {}
        let panelData = this.getPanelData()
        //关闭页面并失焦
        this.props.onHidden()
        setTimeout(() => {
            //改变记录顺序
            let data = this.setFront(panelData['viewed'], index)
            //更新本地panelData
            this.setPanelData('viewed', data)
            if (id) { //其他档案跳转
                pageTo.openTo(null, {
                    appcode,
                    pagecode,
                    status: 'browse',
                    id
                });
            } else { //应用菜单跳转
                window.openNew(item, null, null, {
                    openTabWithoutCheck: false
                });
            }
        }, 150)
    }

    //将数组的某一项提到最前面，数据结构[{},{},{}],不存在重复项
    setFront = (arr, index) => {
        arr.unshift(...arr.splice(index, 1))
        return arr
    }

    /**
       * 文本超过最大宽度显示气泡
       * @params target  目标元素
       * @params maxWidth 最大宽度
      */
    isRenderTip = (target, maxWidth) => {
        let domWidth = (findDOMNode(this).querySelector(target) || {}).offsetWidth || 0
        if (domWidth >= maxWidth) {
            return true
        } else {
            return false
        }
    }
}


export default HistoryPanel;